import React from 'react'
import BooksList from '../Components/BooksList';

const Books = () => {
  return (
    <div>
      <BooksList />
    </div>
  )
}

export default Books
